import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Stack, Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { useVerticalMode } from '../../controllers/feature-context.tsx';

const jqlBuilderContainerStyles = cssMap({
	list: {
		paddingBlockEnd: token('space.100'),
		paddingInline: token('space.0'),
		width: '100%',
	},
	wrapperOverflow: {
		paddingBlockEnd: token('space.600'),
		maxWidth: '100%',
		height: '100%',
		width: '100%',
	},
	actions: {
		position: 'absolute',
		width: '100%',
		bottom: '0',
		left: '0',
		paddingBlockStart: token('space.100'),
		paddingBlockEnd: token('space.600'),
		paddingInline: token('space.300'),
		boxShadow: token('elevation.shadow.overflow'),
	},
	fieldList: {
		paddingInline: token('space.0'),
		maxHeight: '402px',
		overflowY: 'auto',
		width: '100%',
	},
});

export const JQLBuilderContainer = ({
	children,
	footer,
}: {
	children: React.ReactNode;
	footer?: React.ReactNode;
}) => {
	const verticalMode = useVerticalMode();

	if (verticalMode) {
		if (!footer) {
			return (
				<Stack as="ul" xcss={jqlBuilderContainerStyles.list}>
					{children}
				</Stack>
			);
		}
		return (
			<Stack xcss={jqlBuilderContainerStyles.wrapperOverflow}>
				<Stack as="ul" xcss={jqlBuilderContainerStyles.fieldList}>
					{children}
				</Stack>
				<Box xcss={jqlBuilderContainerStyles.actions}>{footer}</Box>
			</Stack>
		);
	}

	return children;
};
